var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"syllabuses"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view',{key:_vm.componentKey,on:{"rerender":_vm.forceRerender}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }